// Fast inverse square root — `Q_rsqrt`, the "what the fuck?" function.
//
// Quake III shipped this in q_math.c: read a float as an integer, shift right,
// subtract the result from 0x5f3759df, read it back as a float, then one Newton
// step. ~0.17 % relative error from a single integer subtract.
//
// The constant's true origin is disputed (Gary Tarolli, Greg Walsh and an SGI
// memo are the usual suspects); the engine is what made it immortal.
//
// Used only for presentation (beam geometry). The simulation keeps IEEE sqrt:
// bit-exact determinism at the simulation rate is worth more than the cycles.

const MAGIC = 0x5f3759df;
const scratch = new Float32Array(1);
const scratchBits = new Int32Array(scratch.buffer);

/** `1 / sqrt(x)` with ~0.17 % relative error. */
export function fastInvSqrt(x: number): number {
  if (!(x > 0)) return 1 / Math.sqrt(x); // 0 -> Infinity, negative -> NaN
  const half = x * 0.5;
  scratch[0] = x;
  const i = scratchBits[0];
  // evil floating point bit level hacking
  scratchBits[0] = MAGIC - (i >> 1); // what the fuck?
  let y = scratch[0];
  y = y * (1.5 - half * y * y); // 1st iteration — the 2nd can be removed
  return y;
}
